import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicToastService } from '@app/services/ui/public-toast/public-toast.service';

@Component({
  selector: 'app-public-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (toast.visible()) {
      @for (toastId of [toast.sequence()]; track toastId) {
        <div
          class="toast-card fixed right-4 top-24 z-[1200] w-[min(calc(100vw-2rem),24rem)] overflow-hidden rounded-2xl border bg-[var(--site-surface)] shadow-[0_20px_50px_rgba(0,0,0,0.18)] backdrop-blur-md"
          [ngClass]="{
            'border-emerald-400/35': toast.type() === 'success',
            'border-red-400/35': toast.type() === 'error',
            'border-amber-400/35': toast.type() === 'warning',
            'border-[var(--site-border)]': toast.type() === 'info',
          }"
        >
          <div class="flex items-start gap-3 px-4 py-3.5">
            <div
              class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold"
              [ngClass]="{
                'bg-emerald-500/12 text-emerald-500': toast.type() === 'success',
                'bg-red-500/12 text-red-500': toast.type() === 'error',
                'bg-amber-500/12 text-amber-500': toast.type() === 'warning',
                'bg-[color-mix(in_srgb,var(--primary-500),transparent_88%)] text-[var(--primary-500)]':
                  toast.type() === 'info',
              }"
            >
              {{ toast.getIcon(toast.type()) }}
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-sm font-semibold text-[var(--site-text)]">
                {{ toast.title() }}
              </p>
              <p class="mt-1 text-sm text-[var(--site-text-muted)]">
                {{ toast.message() }}
              </p>
            </div>
          </div>
          <div
            class="toast-countdown h-1 w-full origin-left"
            [style.--toast-duration]="toastDuration()"
            [ngClass]="{
              'bg-emerald-500/70': toast.type() === 'success',
              'bg-red-500/70': toast.type() === 'error',
              'bg-amber-500/70': toast.type() === 'warning',
              'bg-[var(--primary-500)]/70': toast.type() === 'info',
            }"
          ></div>
        </div>
      }
    }
  `,
  styles: [
    `
      @keyframes publicToastCountdown {
        from {
          transform: scaleX(1);
        }

        to {
          transform: scaleX(0);
        }
      }

      @keyframes publicToastEnter {
        from {
          opacity: 0;
          transform: translateY(-0.75rem) scale(0.98);
        }

        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      .toast-card {
        animation: publicToastEnter 220ms ease-out both;
      }

      .toast-countdown {
        animation: publicToastCountdown var(--toast-duration) linear forwards;
      }

      @media (prefers-reduced-motion: reduce) {
        .toast-card {
          animation: none;
        }
      }
    `,
  ],
})
export class PublicToastComponent {
  readonly toast = inject(PublicToastService);
  readonly toastDuration = computed(() => `${this.toast.durationMs()}ms`);
}

